import createAxios from 'App/utils/createAxios';

const trs = createAxios({
    baseURL: `/trs/reports/1.0.0`,
});

function getExplore(model, explore) {
    return trs.get(`/explore/${model}/${explore}`);
}

function getDefaultDashboard() {
    return trs.get(`/default`);
}

function getReport(type, id) {
    return trs.get(`/${type}/${id}`);
}

function getTherigyContent() {
    return trs.get(`/content/therigy`);
}

function getUser(userId) {
    return trs.get(`/user/${userId}`);
}

function getUserContent() {
    return trs.get(`/content/user`);
}

export { getDefaultDashboard, getExplore, getReport, getTherigyContent, getUser, getUserContent };
